export const toDateStringSafe = (d: Date | undefined): string | null => {
  if (d == null) return null;
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().split('T')[0];
};
